import { useTranslations } from "@zapier/i18n";
import { EmptyFolderTableTypes } from "./useShowEmptyFolderTable";
import { FolderCreationModal } from "../../FolderCreationModal";
import { useAccountActionPermissions } from "@zapier/client";
import {
  EmptyTableDisplay,
  FolderActionInteractionOption,
  FolderModal,
  useEmitFolderActionEvent,
  useRouterParams,
} from "@zapier/shared";
import { FolderTypeQueryState } from "@zapier/utils";
import { TeamsUpsell } from "./TeamsUpsell";

interface Props {
  tableType: EmptyFolderTableTypes;
  folderType: FolderTypeQueryState | null | undefined;
  setCurrentFolderModal: (modal: FolderModal | undefined) => void;
  currentFolderModal: FolderModal | undefined;
}

export function EmptyFolderTable({
  tableType,
  folderType,
  setCurrentFolderModal,
  currentFolderModal,
}: Props) {
  const t = useTranslations("empty-folder-table");

  const { emit } = useEmitFolderActionEvent();
  const { clearFilterParams } = useRouterParams();
  const { isSharingEnabled } = useAccountActionPermissions();

  /* Empty Search OR Owner Filter */
  if (tableType === EmptyFolderTableTypes.EmptySearchResults) {
    return (
      <EmptyTableDisplay
        actionButtonText={t("actions.clear-search")}
        headerText={t("messages.no-results-found")}
        icon="navSearch"
        onActionButton={() => clearFilterParams()}
        subHeaderText={t("messages.adjust-filters-hint")}
      />
    );
  }

  /* Upgrade for sharing */
  if (tableType === EmptyFolderTableTypes.UpgradeForSharing) {
    return <TeamsUpsell />;
  }

  /* Empty folders list */
  if (tableType === EmptyFolderTableTypes.NoFolders) {
    return (
      <>
        <EmptyTableDisplay
          icon={
            folderType === FolderTypeQueryState.Shared ? "team" : "navFolder"
          }
          headerText={
            folderType === FolderTypeQueryState.Shared
              ? t("messages.no-shared-folders")
              : t("messages.no-folders-created")
          }
          subHeaderText={t("messages.create-folders-description")}
          actionButtonText={t("buttons.create-folder")}
          actionButtonIcon="formAdd"
          onActionButton={() => {
            emit({
              optionSelected: FolderActionInteractionOption.CreateFolder,
              interactionRawText: FolderTypeQueryState.Personal,
            });
            setCurrentFolderModal(FolderModal.Create);
          }}
        />
        <FolderCreationModal
          isOpen={currentFolderModal === FolderModal.Create}
          isShared={folderType === FolderTypeQueryState.Shared ? true : false}
          isSharedSelectable={isSharingEnabled}
          setIsOpen={() => setCurrentFolderModal(undefined)}
        />
      </>
    );
  }

  return;
}
